<template>
  <div></div>
</template>

<script>
import { nowMs } from '@/common/responseOffset'

export default {
  name: 'WaitingOrder',
  props: {
    locale: { type: Object, default: () => ({}) },
    isStore: { type: Boolean, default: false },
    responsive: { type: String, default: 'mobile' },
    shopPageId: { type: String, default: '' }
  },
  computed: {
    orderLimitSetting () {
      return this.$store.getters['shop/getShopOrderLimit'](this.shopPageId) || {}
    },
    lastOrderTime () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      return this.$store.getters['shop/getLastOrderTime'](shopCatCode)
    },
    // 대기 종료 여부: left가 0이면 true(=지금 주문 가능)
    passed () {
      return this.left <= 0
    },
    // 남은 "분"(올림, 0이면 0)
    minutesLeft () {
      if (this.left <= 0) return 0
      return Math.max(1, Math.ceil(this.left / 60000))
    }
  },
  async created () {
    // 스토어 준비 전일 수 있으니 초기화 watch
    if (this.canInit()) {
      this.init()
    } else {
      this._unwatchReschedule = this.$watch(
        () => [this.lastOrderTime, this.orderLimitSetting && this.orderLimitSetting.waitingOrder],
        () => { if (!this._inited && this.canInit()) this.init() },
        { deep: false, immediate: true }
      )
    }
    // 값 변경 시 재스케줄
    this.$watch(
      () => [this.lastOrderTime, this.orderLimitSetting && this.orderLimitSetting.waitingOrder],
      () => { if (this._inited) this.reschedule() },
      { deep: false }
    )
    document.addEventListener('visibilitychange', this.onWake)
    window.addEventListener('pageshow', this.onWake)
  },
  beforeDestroy () {
    this.teardown()
  },
  data () {
    return {
      endTime: null, // 마지막 주문 + n분 (ms)
      left: 0, // 현재 남은 시간(ms)
      tickId: null, // setInterval id
      _inited: false, // 초기화 여부
      _unwatchInit: null, // 초기 watch (default에서 첫 변경 감지)
      _unwatchReschedule: null
    }
  },
  methods: {
    canInit () {
      const iso = this.lastOrderTime
      const waitMin = Number(this.orderLimitSetting.waitingOrder)
      return !!iso && Number.isFinite(waitMin) && waitMin >= 0
    },
    init () {
      const MIN = 60 * 1000
      const iso = this.lastOrderTime
      const waitMin = Number(this.orderLimitSetting.waitingOrder) || 0
      // 마지막 주문이 없거나 대기가 0이면 곧바로 통과
      if (!iso || waitMin <= 0) {
        this.clearTimers()
        this.left = 0
        this.commitTimeLeft()
        this._inited = true
        this.emitChange()
        this.unwatchInit()
        return
      }
      const lastMs = new Date(iso).getTime()
      if (!Number.isFinite(lastMs)) {
        // 파싱 실패 시 안전하게 통과 처리
        this.clearTimers()
        this.left = 0
        this.commitTimeLeft()
        this._inited = true
        this.emitChange()
        this.unwatchInit()
        return
      }
      this.endTime = lastMs + waitMin * MIN

      // 서버 시간으로 보정된 nowMs로 remaining 계산
      this.left = Math.max(0, this.endTime - nowMs())
      this.commitTimeLeft()

      this.clearTimers()
      if (this.left <= 0) {
        this._inited = true
        this.emitChange()
        this.unwatchInit()
        return
      }

      this.tickId = setInterval(this.updateLeft, 1000)
      this.updateLeft()

      this._inited = true
      this.unwatchInit()
    },
    reschedule () {
      // 설정/마지막 주문시간 변경 → 다시 init
      this._inited = false
      this.init()
    },
    updateLeft () {
      if (!this.endTime) {
        const prev = this.left
        this.left = 0
        this.commitTimeLeft()
        if (prev !== 0) this.emitChange()
        return
      }

      const prev = this.left
      this.left = Math.max(0, this.endTime - nowMs())
      this.commitTimeLeft()

      // 0 통과 순간만 알리면 충분
      if ((prev > 0 && this.left === 0) || (prev === 0 && this.left > 0)) {
        this.emitChange()
      }
    },
    onWake () {
      if (!document.hidden) {
        // 잠자는 동안 흘렀던 시간 반영
        this.reschedule()
      }
    },
    emitChange () {
      // 부모로 “대기 통과 여부” boolean 전달
      this.$emit('cooldown-change', this.passed)
    },
    clearTimers () {
      if (this.tickId) {
        clearInterval(this.tickId)
        this.tickId = null
      }
    },
    unwatchInit () {
      if (this._unwatchInit) {
        this._unwatchInit()
        this._unwatchInit = null
      }
    },
    teardown () {
      this.clearTimers()
      this.left = 0
      this.commitTimeLeft()
      this._inited = true
      this.emitChange()
      this.unwatchInit()
      document.removeEventListener('visibilitychange', this.onWake)
      window.removeEventListener('pageshow', this.onWake)
      this.unwatchInit()
      if (this._unwatchReschedule) {
        this._unwatchReschedule()
        this._unwatchReschedule = null
      }
      this.commitTimeLeft()
    },
    commitTimeLeft () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      // timeLeft(ms)를 저장. 0 이하면 store에서 자동으로 삭제됨
      this.$store.commit('shop/setWaitingOrder', {
        catCode: shopCatCode,
        timeLeft: this.minutesLeft
      })
    },
  }
}
</script>
